import React, { useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    LuArrowLeft,
    LuBadgeCheck,
    LuCircleAlert,
    LuKeyRound,
    LuLock
} from 'react-icons/lu';

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

function ResetPassword() {
    const query = useQuery();
    const navigate = useNavigate();
    const { resetPassword } = useAuth();

    const [token, setToken] = useState(query.get('token') || '');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setMessage('');

        if (!token.trim()) {
            setError('Sıfırlama tokenı zorunludur.');
            return;
        }

        if (!password || !confirmPassword) {
            setError('Yeni şifre ve tekrar alanları zorunludur.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Şifreler eşleşmiyor.');
            return;
        }

        if (password.length < 6 || !/\d/.test(password)) {
            setError('Şifre en az 6 karakter olmalı ve en az bir rakam içermelidir.');
            return;
        }

        setLoading(true);

        try {
            const response = await resetPassword(token.trim(), password);
            setSuccess(true);
            setMessage(response.message || 'Şifre başarıyla değiştirildi.');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container auth-container-single">
                <div className="auth-form-section">
                    <div className="auth-form-wrapper">
                        <Link to="/login" className="back-link">
                            <LuArrowLeft /> Girişe Dön
                        </Link>

                        <div className="auth-header">
                            <div className="auth-logo">
                                <LuKeyRound />
                            </div>
                            <h1>Şifreyi Yenile</h1>
                            <p>E-postadaki token ile yeni şifrenizi belirleyin.</p>
                        </div>

                        {success ? (
                            <div className="success-state">
                                <div className="success-icon">
                                    <LuBadgeCheck />
                                </div>
                                <h2>Şifre Güncellendi</h2>
                                <p>{message}</p>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-block"
                                    onClick={() => navigate('/select-mode', { replace: true })}
                                >
                                    Devam Et
                                </button>
                            </div>
                        ) : (
                            <>
                                {error && (
                                    <div className="auth-error">
                                        <LuCircleAlert className="error-icon" />
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="auth-form">
                                    <div className="form-group">
                                        <label>Sıfırlama Tokenı</label>
                                        <div className="input-with-icon">
                                            <LuKeyRound className="input-icon" />
                                            <input
                                                type="text"
                                                className="form-input has-icon"
                                                value={token}
                                                onChange={(e) => setToken(e.target.value)}
                                                placeholder="E-postadaki token"
                                                required
                                                autoCapitalize="off"
                                                autoCorrect="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Yeni Şifre</label>
                                        <div className="input-with-icon">
                                            <LuLock className="input-icon" />
                                            <input
                                                type="password"
                                                className="form-input has-icon"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Yeni şifre"
                                                required
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Şifre Tekrar</label>
                                        <div className="input-with-icon">
                                            <LuLock className="input-icon" />
                                            <input
                                                type="password"
                                                className="form-input has-icon"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                placeholder="Şifreyi tekrar girin"
                                                required
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-small"></span>
                                                İşleniyor
                                            </>
                                        ) : (
                                            'Şifreyi Güncelle'
                                        )}
                                    </button>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
